// extracted by mini-css-extract-plugin
module.exports = {"link":"AppLogo_link__21cCk","image":"AppLogo_image___482l"};